import React from 'react';

// Interfaces
import { DrugAdministrationList } from '../../../interfaces/Drug';
import CellSumContent from '../CellSumContent/CellSumContent';
import CellContent from '../CellContent/CellContent';

const ContentCells: React.FC<{
    drug: DrugAdministrationList,
    hour?: string,
    dates: string[],
    readOnly: boolean
    handleSetDrugs: (updateDrugs: (oldDrugs: DrugAdministrationList[]) => DrugAdministrationList[]) => void
}> = ({ drug, hour, dates, readOnly, handleSetDrugs }) => {
    
    return (
        <>
            {dates.map(date =>
                hour === undefined ?
                    <CellSumContent key={drug.drugId + drug.drugName + 'global' + date}
                        date={date}
                        drug={drug}
                    />
                    :
                    <CellContent key={drug.hours[hour][date] !== undefined ? drug.hours[hour][date][0].id : drug.drugId + 'undefined' + date}
                        date={date}
                        hour={hour}
                        drug={drug}
                        readOnly={readOnly}
                        handleSetDrugs={handleSetDrugs}
                    />
            )}
        </>
    );
};

export default ContentCells;